import { render, staticRenderFns } from "./QueryPublicDocument.vue?vue&type=template&id=389e233a&scoped=true"
import script from "./QueryPublicDocument.vue?vue&type=script&lang=js"
export * from "./QueryPublicDocument.vue?vue&type=script&lang=js"
import style0 from "./QueryPublicDocument.vue?vue&type=style&index=0&id=389e233a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e233a",
  null
  
)

export default component.exports